import axios from "@/axios/axios";

const actions = {
  async GET_ALL(context){
    try{
      let {data} = await axios.get('u_debts', {
        params: {
          account_number: context.rootGetters['appUser/client/aparts/selected'].account_number
        }
      });
      context.commit('SET_ALL', data);
    }
    catch(e){
      context.commit('SET_ALL', []);
    }
  }
};

export default actions;